"use client";

import { useState, useEffect } from "react";
import { ArrowRight, Sparkles, Zap, ShieldCheck, Droplets, HeartPulse, Syringe, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
export default function Transformation() {
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    setIsOpen(true);
  }, []);
  return <section data-section-id="4535" id="octoberspecialsmodal" className="bg-background text-foreground relative w-full overflow-hidden py-24 md:py-32">
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/wellness_sanctuary_interior.png)] opacity-30" />
      <div className="absolute inset-0" style={{
      background: "linear-gradient(135deg, hsla(0, 0%, 10%, 0.85) 0%, hsla(0, 0%, 10%, 0.6) 50%, hsla(0, 0%, 10%, 0.75) 100%)"
    }} />

      <div className="relative z-10 mx-auto flex max-w-[800px] flex-col items-center px-6 text-center">
        <h2 className="font-serif font-default text-primary-foreground leading-[1.05] tracking-tight mb-6" style={{
        fontFamily: "var(--font-serif)",
        fontWeight: 400,
        fontSize: "clamp(2.5rem, 6vw, 4.5rem)"
      }}>
          Exclusive October Specials
        </h2>

        <p className="mb-10 max-w-[560px] text-base leading-relaxed text-primary-foreground/80 md:text-lg">
          Discover our curated wellness services and protocols designed for your vitality at our Midland, Texas location.
        </p>

        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogTrigger asChild>
            <Button size="lg" className="group h-auto rounded-lg bg-[hsl(38,35%,58%)] px-8 py-4 text-base font-medium text-white shadow-lg hover:bg-[hsl(38,35%,50%)] transition-all">
              <Sparkles className="mr-2 size-4" />
              View October Specials
            </Button>
          </DialogTrigger>

          <DialogContent className="sm:max-w-[850px] max-h-[90vh] overflow-y-auto p-6 md:p-8 bg-card text-card-foreground border border-[hsl(38,35%,58%)]/30 shadow-2xl rounded-lg">
            <DialogHeader className="space-y-3 text-center sm:text-left">
              <div className="flex items-center justify-center sm:justify-start gap-2 text-[hsl(38,35%,58%)] font-mono text-xs uppercase tracking-widest">
                <Sparkles className="size-4" />
                Limited Time Offer — Midland & West Texas
              </div>
              <DialogTitle className="font-serif text-2xl md:text-3xl font-normal text-foreground tracking-tight">
                Limited Time Offer - Midland, Texas
              </DialogTitle>
              <DialogDescription className="text-muted-foreground text-sm md:text-base leading-relaxed">
                Book a wellness consultation and receive 20% off recmmended protocols including customized peptides, vitamin injections, comprehensive lab testing, and exclusive self-care services.
              </DialogDescription>
            </DialogHeader>

            <div className="my-4 rounded-lg bg-secondary/50 p-5 border border-border">
              <h4 className="font-serif text-lg font-medium text-foreground mb-1">Featured October Package</h4>
              <p className="text-sm text-muted-foreground mb-3">
                Book your personalized wellness consultation TODAY!
              </p>
              <div className="flex flex-wrap items-center gap-2 text-xs font-mono text-[hsl(38,35%,58%)] uppercase tracking-wider">
                <span>Valid through October 31</span>
                <span>•</span>
                <span>Midland Studio</span>
              </div>
            </div>

            <div className="my-4">
              <h3 className="font-serif text-center text-lg font-medium text-foreground mb-3">Daily Wellness Specials</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-3">
                {/* Monday Card */}
                <div className="bg-white rounded-lg p-3 border border-[hsl(38,35%,58%)]/30 text-center flex flex-col shadow-xs">
                  <div>
                    <div className="bg-[hsl(38,35%,58%)] text-white text-[11px] font-mono uppercase tracking-wider py-1 rounded-t-sm mb-2">Monday</div>
                    <div className="flex justify-center mb-1 text-[hsl(38,35%,58%)]"><Zap className="size-5" /></div>
                    <h5 className="font-serif font-semibold text-sm text-foreground mb-2">Energy Boost</h5>
                    <div className="space-y-1.5 text-[11px] text-left pt-1 border-t border-border/60">
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">B12</span>
                        <span className="font-bold text-foreground shrink-0">$20</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">B12 Lipo</span>
                        <span className="font-bold text-foreground shrink-0">$30</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">B12 Lipo Plus</span>
                        <span className="font-bold text-foreground shrink-0">$40</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Foot Detox</span>
                        <span className="font-bold text-foreground shrink-0">$25</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Colon Hydrotherapy</span>
                        <span className="font-bold text-foreground shrink-0">$110</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tuesday Card */}
                <div className="bg-white rounded-lg p-3 border border-[hsl(38,35%,58%)]/30 text-center flex flex-col shadow-xs">
                  <div>
                    <div className="bg-[hsl(38,35%,58%)] text-white text-[11px] font-mono uppercase tracking-wider py-1 rounded-t-sm mb-2">Tuesday</div>
                    <div className="flex justify-center mb-1 text-[hsl(38,35%,58%)]"><ShieldCheck className="size-5" /></div>
                    <h5 className="font-serif font-semibold text-sm text-foreground mb-2">Recover + Restore</h5>
                    <div className="space-y-1.5 text-[11px] text-left pt-1 border-t border-border/60">
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">B12</span>
                        <span className="font-bold text-foreground shrink-0">$20</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Tri Boost</span>
                        <span className="font-bold text-foreground shrink-0">$35</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">D3</span>
                        <span className="font-bold text-foreground shrink-0">$35</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <div>
                          <span className="text-muted-foreground block leading-tight">Amethyst BioMat + Vibration Shake Plate</span>
                          <span className="text-[10px] text-muted-foreground/75 block">(1 hour session)</span>
                        </div>
                        <span className="font-bold text-foreground shrink-0">$65</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Wednesday Card */}
                <div className="bg-white rounded-lg p-3 border border-[hsl(38,35%,58%)]/30 text-center flex flex-col shadow-xs">
                  <div>
                    <div className="bg-[hsl(38,35%,58%)] text-white text-[11px] font-mono uppercase tracking-wider py-1 rounded-t-sm mb-2">Wednesday</div>
                    <div className="flex justify-center mb-1 text-[hsl(38,35%,58%)]"><Droplets className="size-5" /></div>
                    <h5 className="font-serif font-semibold text-sm text-foreground mb-2">Detox</h5>
                    <div className="space-y-1.5 text-[11px] text-left pt-1 border-t border-border/60">
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">B12</span>
                        <span className="font-bold text-foreground shrink-0">$20</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Glutathione</span>
                        <span className="font-bold text-foreground shrink-0">$35</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Slim Shot</span>
                        <span className="font-bold text-foreground shrink-0">$45</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Foot Detox</span>
                        <span className="font-bold text-foreground shrink-0">$25</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Colon Hydrotherapy</span>
                        <span className="font-bold text-foreground shrink-0">$110</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Thursday Card */}
                <div className="bg-white rounded-lg p-3 border border-[hsl(38,35%,58%)]/30 text-center flex flex-col shadow-xs">
                  <div>
                    <div className="bg-[hsl(38,35%,58%)] text-white text-[11px] font-mono uppercase tracking-wider py-1 rounded-t-sm mb-2">Thursday</div>
                    <div className="flex justify-center mb-1 text-[hsl(38,35%,58%)]"><HeartPulse className="size-5" /></div>
                    <h5 className="font-serif font-semibold text-sm text-foreground mb-2">Beauty + Longevity</h5>
                    <div className="space-y-1.5 text-[11px] text-left pt-1 border-t border-border/60">
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">B12</span>
                        <span className="font-bold text-foreground shrink-0">$20</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Vitamin C</span>
                        <span className="font-bold text-foreground shrink-0">$30</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Biotin</span>
                        <span className="font-bold text-foreground shrink-0">$35</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">NAD+</span>
                        <span className="font-bold text-foreground shrink-0">$65</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">V-Steam</span>
                        <span className="font-bold text-foreground shrink-0">$79</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Teeth Whitening</span>
                        <span className="font-bold text-foreground shrink-0">$99</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Friday Card */}
                <div className="bg-white rounded-lg p-3 border border-[hsl(38,35%,58%)]/30 text-center flex flex-col shadow-xs">
                  <div>
                    <div className="bg-[hsl(38,35%,58%)] text-white text-[11px] font-mono uppercase tracking-wider py-1 rounded-t-sm mb-2">Friday</div>
                    <div className="flex justify-center mb-1 text-[hsl(38,35%,58%)]"><Syringe className="size-5" /></div>
                    <h5 className="font-serif font-semibold text-sm text-foreground mb-2">Dynamic Duo</h5>
                    <div className="space-y-1.5 text-[11px] text-left pt-1 border-t border-border/60">
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">B12 + Tri Boost</span>
                        <span className="font-bold text-foreground shrink-0">$55</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Slim + Tri Boost</span>
                        <span className="font-bold text-foreground shrink-0">$65</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">B12 + NAD+</span>
                        <span className="font-bold text-foreground shrink-0">$85</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <span className="text-muted-foreground">Tri Boost + NAD+</span>
                        <span className="font-bold text-foreground shrink-0">$95</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <div>
                          <span className="text-muted-foreground block leading-tight">Any other 2 shot combos</span>
                          <span className="text-[10px] text-muted-foreground/75 block">(excluding NAD+)</span>
                        </div>
                        <span className="font-bold text-foreground shrink-0">$75</span>
                      </div>
                      <div className="flex justify-between items-baseline gap-1">
                        <div>
                          <span className="text-muted-foreground block leading-tight">Foot Detox</span>
                          <span className="text-[10px] text-muted-foreground/75 block">(with an injection purchase)</span>
                        </div>
                        <span className="font-bold text-foreground shrink-0">$25</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Midland Hours Block */}
            <div className="rounded-lg bg-secondary/50 p-4 border border-border">
              <div className="flex items-center gap-2 mb-2">
                <Clock className="size-4 text-[hsl(38,35%,58%)]" />
                <h4 className="font-serif text-base font-medium text-foreground">Midland Hours</h4>
              </div>
              <div className="space-y-1 text-xs md:text-sm text-muted-foreground">
                <p>Mon–Fri: 9 AM–4 PM</p>
                <p>After 4 PM & Saturday: By Appointment (Book 24 Hours Prior)</p>
              </div>
            </div>

            {/* Contact Block */}
            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2 text-xs text-muted-foreground font-mono tracking-wider pt-1">
              <span>2003 W Wall St, Ste B, Midland, TX</span>
              <span>•</span>
              <span>432-247-1660</span>
              <span>•</span>
              <span>moprotocol.com</span>
            </div>

            <DialogFooter className="flex flex-col sm:flex-row gap-3 sm:justify-end pt-2">
              <Button asChild variant="outline" className="border-[hsl(38,35%,58%)] text-foreground hover:bg-[hsl(38,35%,58%)]/10 hover:text-foreground h-11 px-6 rounded-lg font-medium">
                <Link to="/ServicesPage">
                  Learn More
                </Link>
              </Button>
              <Button asChild className="bg-[hsl(38,35%,58%)] text-white hover:bg-[hsl(38,35%,50%)] h-11 px-6 rounded-lg font-medium shadow-md">
                <Link to="/BookNowPage">
                  Book Now
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        <p className="mt-12 font-mono text-[11px] tracking-[0.2em] text-primary-foreground/60 uppercase">
          Serving Midland — Odessa — West Texas
        </p>
      </div>
    </section>;
}